import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { dollars } from "@/lib/giftIcons";
import { Crown, Trophy } from "lucide-react";

const resetsIn = (iso) => {
  const ms = new Date(iso) - Date.now();
  if (!(ms > 0)) return "any moment";
  const d = Math.floor(ms / 86400000), h = Math.floor((ms % 86400000) / 3600000);
  return d > 0 ? `${d}d ${h}h` : `${h}h`;
};

// Platform-wide weekly crown race — top gifter of the week wins a month of Premium.
export function CrownRace() {
  const [race, setRace] = useState(null);
  useEffect(() => { api.get("/gifts/crown").then(({ data }) => setRace(data)).catch(() => {}); }, []);
  if (!race) return null;
  return (
    <div data-testid="crown-race" className="rounded-2xl border border-gold/30 bg-gold/5 p-5">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gold"><Crown size={14} /> This week's crown race</p>
        <p data-testid="crown-resets" className="text-[11px] text-text-muted">Resets in {resetsIn(race.resets_at)} · prize: {race.prize}</p>
      </div>
      <div className="mt-4 grid sm:grid-cols-[1fr_auto] gap-4 items-start">
        <div className="space-y-2.5">
          {race.standings.length === 0 && <p data-testid="crown-empty" className="text-sm text-text-muted">No gifts yet this week — be the first admirer on the board.</p>}
          {race.standings.map((t, i) => (
            <div key={t.user_id} data-testid={`crown-rank-${i + 1}`} className="flex items-center gap-3">
              <span className={`w-6 h-6 rounded-full border flex items-center justify-center text-[11px] ${i === 0 ? "border-gold text-gold" : "border-white/20 text-text-muted"}`}>{i + 1}</span>
              {t.photo_url && <img src={t.photo_url} alt="" className={`w-7 h-7 rounded-full object-cover border border-white/10 ${t.discreet_mode ? "blur-sm" : ""}`} />}
              <span className="text-sm flex-1 truncate">{t.name}</span>
              <span className="text-sm text-gold">{dollars(t.total)}</span>
            </div>
          ))}
        </div>
        <div className="text-xs text-text-muted sm:text-right space-y-1.5">
          <p data-testid="crown-mine">You've gifted <span className="text-text-main">{dollars(race.my_week_total)}</span> this week</p>
          {race.last_week_crown && (
            <p data-testid="crown-last-week" className="flex items-center gap-1.5 sm:justify-end"><Trophy size={12} className="text-gold" /> Last week: <span className="text-gold">{race.last_week_crown.name}</span></p>
          )}
          {race.bonus_premium_until && <p data-testid="crown-my-bonus" className="text-gold">Your Premium prize runs to {race.bonus_premium_until.slice(0, 10)}</p>}
        </div>
      </div>
    </div>
  );
}
